import React, { useState, useEffect } from "react";
import "../styles/admin.css";
import { API_BASE } from "../config";
import AdminSidebar from "../components/admin/AdminSidebar";
import DashboardHome from "../components/admin/DashboardHome";
import ProductManager from "../components/admin/ProductManager";
import MessageInbox from "../components/admin/MessageInbox";
import SiteSettingsManager from "../components/admin/SiteSettingsManager";

function Admin() {
  const [token, setToken] = useState(sessionStorage.getItem("adminToken") || "");
  const [loggedIn, setLoggedIn] = useState(!!sessionStorage.getItem("adminToken"));
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [activeTab, setActiveTab] = useState("dashboard");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const previousTitle = document.title;
    document.title = "KrivaExim | Admin";
    return () => { document.title = previousTitle; };
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Login failed");
      sessionStorage.setItem("adminToken", data.token);
      setToken(data.token);
      setLoggedIn(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    sessionStorage.removeItem("adminToken");
    setToken("");
    setLoggedIn(false);
    setEmail("");
    setPassword("");
  };

  if (!loggedIn) {
    return (
      <main className="admin-login">
        <form onSubmit={handleLogin}>
          <h1>Admin Login</h1>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          {error && <p className="admin-error">{error}</p>}
          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>
      </main>
    );
  }

  return (
    <div className="admin-layout">
      <AdminSidebar
        activeTab={activeTab}
        onTabChange={setActiveTab}
        onLogout={handleLogout}
      />
      <main className="admin-main">
        <div className="admin-main-header">
          <h1>{activeTab === "dashboard" ? "Dashboard" : activeTab.charAt(0).toUpperCase() + activeTab.slice(1)}</h1>
        </div>
        <div className="admin-main-content">
          {activeTab === "dashboard" && <DashboardHome token={token} onNavigate={setActiveTab} />}
          {activeTab === "products" && <ProductManager token={token} />}
          {activeTab === "messages" && <MessageInbox token={token} />}
          {activeTab === "settings" && <SiteSettingsManager token={token} />}
        </div>
      </main>
    </div>
  );
}

export default Admin;
